<div class="content wz-table-step">

  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">{{ mapName }} <span class="gold">religions</span></h2>
  </div>

  <p class="wz-lead">Add details to steer the AI for each religion. <strong>Everything here is optional</strong>: leave a row blank and the AI decides.</p>

  <div class="scroll-container flex-grow-1 px-3">
    <!-- Chaos Level Row -->
    <div class="chaos-level-row mb-4 d-flex align-items-center justify-content-center gap-3">
      <label for="religionChaosLevel" class="chaos-label fw-bold">Chaos level</label>
      <div class="select-wrapper custom-select-width">
        <ng-select class="wt-select" id="religionChaosLevel" [(ngModel)]="religionChaosLevel" [items]="chaosLevels"
          placeholder="Choose…" [clearable]="false" appendTo="body">
          <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
        </ng-select>
      </div>
    </div>

    <!-- Table Container -->
    <div class="table-container mx-auto">
      <table class="religions-table w-100">
        <thead>
          <tr>
            <th class="col-name text-left">Name</th>
            <th class="col-zeal text-left">Religion Zeal</th>
            <th class="col-pressure text-left">Convert Pressure</th>
            <th class="col-notes text-left">Notes</th>
          </tr>
        </thead>
        <tbody>
          @for (religion of religionsList; track religion; let i = $index) {
            <tr>
              <!-- Name -->
              <td class="col-name">
                <span class="religion-name-text">{{ religion.name }}</span>
              </td>
              <!-- Religion Zeal -->
              <td class="col-zeal">
                <div class="select-wrapper">
                  <ng-select class="wt-select" [(ngModel)]="religion.zeal" [items]="zeals"
                    placeholder="Choose…" [clearable]="false" appendTo="body">
                    <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                  </ng-select>
                </div>
              </td>
              <!-- Convert Pressure -->
              <td class="col-pressure">
                <div class="select-wrapper">
                  <ng-select class="wt-select" [(ngModel)]="religion.convertPressure" [items]="pressures"
                    placeholder="Choose…" [clearable]="false" appendTo="body">
                    <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
                  </ng-select>
                </div>
              </td>
              <!-- Notes -->
              <td class="col-notes">
                <input type="text" class="form-input" [(ngModel)]="religion.notes"
                  placeholder="Notes for {{ religion.name }} (optional)" />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

    </div>

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    <button type="button" class="btn btn-theme" (click)="onNext()">Next</button>
  </div>

  </div>
